export { getAppKeyFromFullKey, getUniqueAppKeysFromConnectFragments } from './connect-api';
